import { contractorStatusOptions, contractorUserRoleOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { StatusOfContractorUser } from "components/table/columnComponents/StatusOfContractorUser"

export const contractorUsersTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Name",
    type: "sort-search",
    size: "middle",
    name: "name",
  },
  {
    title: "Role",
    size: "middle",
    type: "select",
    name: "role",
    options: contractorUserRoleOptions,
  },
  {
    title: "Email",
    type: "sort-search",
    name: "email",
  },
  {
    title: "Phone",
    type: "sort-search",
    name: "phone",
  },
  {
    title: "Creation date",
    type: "sort-date",
    name: "creation_date",
  },
  {
    title: "Status",
    type: "select",
    name: "is_enabled",
    options: contractorStatusOptions,
    cellComponent: StatusOfContractorUser,
  },
  {
    title: "Created By",
    type: "sort-search",
    name: "created_by",
  },
]
